import React, { useState, useEffect, useRef } from "react"; 
import { auth } from '../../components/OurCourses/firebase'; 
import logoImg from "../../assets/round-eyecare.webp";
import "./style.css";


import { Link, useNavigate } from 'react-router-dom'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 


// import { usePopup } from '../BodyComp/PopupContext'; // 


export const NavComp = () => {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };



  const navRef = useRef(null);

  // Function to close the navbar
  const closeNavbar = () => {
    if (navRef.current.classList.contains("show")) {
      navRef.current.classList.remove("show");
    }
  };


  







  return (
    <nav className="navbar navbar-expand-lg navbar-dark sticky-top" style={{ backgroundColor: 'rgb(17, 24, 39)' }}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src={logoImg} alt="logo" className="img-fluid rounded-circle" height="60" />
        </Link>
        
        <button
          className="navbar-toggler mobile-toggle-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            width: '40px',
            height: '40px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav" ref={navRef}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item mx-3">
              <Link to="/" className="nav-link" onClick={closeNavbar}>Home</Link>
            </li>

            <li className="nav-item mx-3 dropdown">
              <Link className="nav-link dropdown-toggle" to="#" id="aboutUsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                About Us
              </Link>
              <ul className="dropdown-menu" aria-labelledby="aboutUsDropdown">
                <li><Link to="/whoweare" className="dropdown-item" onClick={closeNavbar}>Who We Are</Link></li>
                <li><Link to="/academicboard" className="dropdown-item" onClick={closeNavbar}>Academic Board</Link></li>
                <li><Link to="/codeofethics" className="dropdown-item" onClick={closeNavbar}>Code of Ethics</Link></li>
                <li><Link to="/ourfaculty" className="dropdown-item" onClick={closeNavbar}>Our Faculty</Link></li>
                <li><Link to="/alumni" className="dropdown-item" onClick={closeNavbar}>Alumni</Link></li>
                <li><Link to="/aboutoptometry" className="dropdown-item" onClick={closeNavbar}>About Optometry</Link></li>
                <li><a href="https://optometryassociation.lk"  className="dropdown-item" target="_blank" rel="noopener noreferrer" onClick={closeNavbar}>Ceylon Eye Care Optometry Association</a></li>
              </ul>
            </li>

            {/* <li className="nav-item mx-3 dropdown">
              <Link className="nav-link dropdown-toggle" to="#" id="ourCoursesDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Our Courses
              </Link>
              <ul className="dropdown-menu" aria-labelledby="ourCoursesDropdown">
                <li><Link to="/certificateinoptician" className="dropdown-item" onClick={closeNavbar}>Certificate in Optician</Link></li>
                <li><Link to="/diplomainoptometry" className="dropdown-item" onClick={closeNavbar}>Diploma in Optometry</Link></li>
                <li><Link to="/higherdiplomainoptometry" className="dropdown-item" onClick={closeNavbar}>Higher Diploma in Optometry</Link></li>
                <li><Link to="/fellowshipcourse" className="dropdown-item" onClick={closeNavbar}>Fellowship Course</Link></li>
                <li><Link to="/onedayworkshop" className="dropdown-item" onClick={closeNavbar}>Fellowship Workshops</Link></li>
              </ul>
            </li> */}

            <li className="nav-item mx-3">
              <Link to="/ourcourses" className="nav-link" onClick={closeNavbar}>Our Courses</Link>
            </li>

            <li className="nav-item mx-3">
              <Link to="/gallery" className="nav-link" onClick={closeNavbar}>Gallery</Link>
            </li>

            <li className="nav-item mx-3 dropdown">
              <Link className="nav-link dropdown-toggle" to="#" id="newsEventsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                News & Events
              </Link>
              <ul className="dropdown-menu" aria-labelledby="newsEventsDropdown">

                <li><Link to="/newsandevents" className="dropdown-item" onClick={closeNavbar}>News & Events</Link></li>
                <li><Link to="/eyecarecareer" className="dropdown-item" onClick={closeNavbar}>Eye Care Career</Link></li>
              </ul>
            </li>




            <li className="nav-item mx-3">
              <Link to="/contactus" className="nav-link" onClick={closeNavbar}>Contact Us</Link>
            </li>

            <li className="nav-item mx-3">
              <Link to="/download" className="nav-link" onClick={closeNavbar}>Payment Portal</Link>
            </li>

            <li className="nav-item mx-3">
              <Link to="/verification" className="nav-link" onClick={closeNavbar}>Certificate Verification</Link>
            </li>

            {/* <li className="nav-item mx-3">
              <Link to="/findyouroptometrist" className="nav-link" onClick={closeNavbar}>Find Your Optometrist Here</Link>
            </li>  */}


            {/*    stlogin-button-style         */}


            <li className="nav-item mx-3">
              <a href="https://lms.eyecareinstitute.lk" className="nav-link " target="_blank" rel="noopener noreferrer">
                 LMS
              </a>
            </li>


                    {/* Add Sign In and Sign Up buttons inside the toggle menu */}
        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN IN</button>
            </Link>
            <Link to="/signup">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN UP</button>
            </Link>
          </li>
        )}

          </ul>




      <div className="navbar-buttons">
        {isLoggedIn ? (
          <>
    
            <div className="user-menu-container">
              <button className="user-icon" onClick={toggleDropdown}>
                <FaUserCircle size={24} /> <FaCaretDown size={16} />
              </button>
              {showDropdown && (
                <ul className="user-dropdown" ref={dropdownRef}>
                  <li>
                    <Link to="/userprofile" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/viewapplication" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments 
                    </Link>
                  </li>

                  <li>
                    <Link to="/viewpayment" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                    </Link>
                  </li>


                  <li>
                    <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
      </div>




        </div>
      </div>
    </nav>
  );
};
